export default function isLikeNull(value: string | null) {
  if (value === null || value === '' || value === 'null') {
    return true;
  }
  return false;
}
